import axios from 'axios';

export default function (context, {data, cb}) {
    context.state.loading = true;
    context.commit('clean');
    axios({
        method: 'post',
        url: '/tourclient/payment/currentRegular',
        data: 'request=' + JSON.stringify(data),
        requestId: 'tourclient/payment/currentRegular'
    }).then(({data}) => {
        data.user = context.rootGetters['dictionary/user/getById'](context.rootState.user.id);
        context.commit('set', data);
        if (cb) cb(data);
    }).catch(e => {
        context.state.loading = false;
        context.dispatch('error', e, {root: true});
    });
}